import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { removeAuthorizedDomain } from '../../../spots/spotsActions';

class DomainItem extends Component {
  removeDomain() {
    const { domain } = this.props;
    this.props.removeDomain(domain);
  }

  render() {
    return (
      <div className="domain-item">
        <span className="domain" title={this.props.domain}>
          {this.props.domain}
        </span>
        <span className="remove-button remove-domain" onClick={this.removeDomain.bind(this)}>
          Remove
        </span>
      </div>
    );
  }
}

DomainItem.propTypes = {
  domain: PropTypes.string.isRequired
};

DomainItem.displayName = 'DomainItem';

function mapDispatchToProps(dispatch) {
  return {
    removeDomain: payload => dispatch(removeAuthorizedDomain(payload))
  };
}

export default connect(undefined, mapDispatchToProps)(DomainItem);
